var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3790_3847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20837 2.44855L13.4465 7.4798C13.5878 7.6155 13.6678 7.80354 13.6678 8.0003C13.6678 8.19706 13.5878 8.38483 13.4465 8.52079L8.20837 13.552C7.92284 13.8253 7.47087 13.815 7.19826 13.5277C6.92576 13.2432 6.93599 12.7865 7.22244 12.5113L11.1718 8.71987H1.04796C0.653612 8.71987 0.333374 8.39763 0.333374 8.00082C0.333374 7.60401 0.653612 7.28237 1.04796 7.28237H11.17L7.22058 3.49097C6.93456 3.21522 6.92564 2.75852 7.19647 2.47311C7.47028 2.18561 7.89587 2.17543 8.20837 2.44855Z",
    fill: "#0E7490"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3790_3847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 15.3333,
    fill: "white",
    transform: "translate(0.333374 0.333328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRegular);
export default __webpack_public_path__ + "static/media/arrow-right-regular.3c6bec4a4ef4bc030a035bdb0fd049dc.svg";
export { ForwardRef as ReactComponent };